import EventRegistrations from "./EventRegistrations";
export default EventRegistrations;
